import React from 'react'
import { YumLegacyGoalRankingTable, YumLegacyGoalRankingTableHandle } from './YumLegacyGoalRankingTable'
import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import { getUserDto, getUserCompanies } from '../../common/auth/authSelectors'
import {
  getActivityProgress,
  getActivityProgressLoading,
  getDivisionActivityProgress,
  getCountryActivityProgress,
  getActivityPeriodPercentage,
} from '../../views/Activity/store/ActivitySelectors'
import { ActivityView } from '../../views/Activity/store/ActivityReducer'
import {
  ActivityProgress,
  CountryActivityProgress,
  DivisionActivityProgress,
  GoalWithProgress,
  GroupView,
  UserCompanyDto,
  UserProfileDto,
} from '../../services/api.types'

interface IOwnProps {
  goalDto: GoalWithProgress
  activityView: ActivityView
  groupView: GroupView
  companyHasCountries: boolean
  /** Whether to use the 2026 layout refresh styling */
  compactLayout?: boolean
}

interface IStateProps {
  userDto: UserProfileDto
  userCompanies: UserCompanyDto[]
  activityProgress: ActivityProgress[]
  divisionActivityProgress: DivisionActivityProgress[]
  countryActivityProgress: CountryActivityProgress[]
  activityPeriodPercentage: number
  activityProgressLoading: boolean
}

const mapStateToProps = (state: IGlobalState, ownProps: IOwnProps): IStateProps => {
  const { goalDto } = ownProps
  const goalId = goalDto.id

  return {
    userDto: getUserDto(state),
    userCompanies: getUserCompanies(state),
    activityProgress: getActivityProgress(state, goalId),
    divisionActivityProgress: getDivisionActivityProgress(state, goalId),
    countryActivityProgress: getCountryActivityProgress(state, goalId),
    activityPeriodPercentage: getActivityPeriodPercentage(state, goalId),
    activityProgressLoading: getActivityProgressLoading(state, goalId),
  }
}

// Create a component that accepts a ref
const TableComponent = React.forwardRef<YumLegacyGoalRankingTableHandle, IOwnProps & IStateProps>((props, ref) => (
  <YumLegacyGoalRankingTable {...props} ref={ref} />
))

// Use the forwardRef option in connect
export default connect<IStateProps, {}, IOwnProps, IGlobalState>(mapStateToProps, null, null, { forwardRef: true })(
  TableComponent,
)
